import React from 'react';
import { Logout } from 'react-admin';
import { connect } from 'react-redux';
import { userLogout } from 'react-admin';
import { environmentValues } from '../App.js';

const LogoutButton = props => {
    const handleClick = event => {
        const env = environmentValues();

        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

        const params = new URLSearchParams();
        params.append("post_logout_redirect_uri", env.redirectUri);

        const logoutUrl = `${env.authUrl}/connect/logout?${params.toString()}`;
        console.log(logoutUrl)
        window.location.href = logoutUrl;
       // localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('refresh_token');

      //  props.userLogout();
    };

    return <Logout {...props} onClick={handleClick} />;
};

export default connect(undefined, { userLogout })(LogoutButton);